import PlanChooser from '../components/PlanChooser';

// Public "Pricing & Plans" page (§7). The plan grid, billing toggle, purchase flow and the
// feature-comparison table all live in the shared <PlanChooser> (membership_approval_flow.md) so
// the same experience powers the expired-membership gate.
export default function Pricing() {
  return (
    <div className="py-4">
      <div className="text-center mb-4">
        <h2>Pricing &amp; Plans</h2>
        <p className="text-muted">Start free, upgrade when you grow. Prices in INR, taxes extra.</p>
      </div>
      <PlanChooser showComparison />
    </div>
  );
}
